import type { FestivalConfig } from "@/lib/festival-weather/types";
import type { FestivalQuizData, GenreAffinity } from "./quiz-data";

/** Editorial matching weights, not measured audience statistics or ratings. */
export function catalogueQuizProfile(festival: FestivalConfig): FestivalQuizData {
  const genres = new Set(festival.genre ?? []);
  const electronic = genres.has("electronic") || genres.has("dance");
  const rock = genres.has("rock") || genres.has("metal") || genres.has("indie");
  const folk = genres.has("folk") || genres.has("world") || genres.has("country");
  const tags: GenreAffinity[] = [];
  if (electronic) tags.push("electronic");
  if (rock) tags.push("rock");
  if (folk) tags.push("folk");
  if (genres.has("hip-hop")) tags.push("urban");
  const camping = festival.camping === "on-site";
  const winter = ["snowbombing", "snowboxx", "tomorrowland-winter"].includes(festival.slug);
  const oneDay = festival.typicalWindow.monthStart === festival.typicalWindow.monthEnd
    && festival.typicalWindow.dayStart === festival.typicalWindow.dayEnd;
  return {
    slug: festival.slug, name: festival.name, region: festival.region,
    locationLabel: `${festival.city}, ${festival.country}`,
    capacity: festival.capacity,
    month: new Date(Date.UTC(2000, festival.typicalWindow.monthStart - 1, 1)).toLocaleDateString("en-GB", { month: "long", timeZone: "UTC" }),
    emoji: winter ? "🏔️" : electronic ? "🎧" : rock ? "🎸" : "🎪",
    gradient: winter ? "linear-gradient(135deg, #1B2840, #1C8A99)" : "linear-gradient(135deg, #1B2840, #5C3A6E)",
    genreTags: tags,
    axes: {
      intimacy: genres.has("boutique") ? 8 : 5,
      productionScale: 5,
      campingComfort: camping ? 3 : festival.camping === "none" ? 8 : 5,
      musicDiscovery: genres.has("indie") || genres.has("world") ? 8 : 6,
      crowdEnergy: electronic || genres.has("metal") ? 8 : 6,
      artsCulture: folk || genres.has("boutique") ? 8 : 4,
      weatherResilience: winter ? 9 : camping ? 7 : 4,
      communityFeel: camping || folk ? 8 : 5,
      durationCommitment: oneDay ? 1 : winter ? 9 : 5,
      genrePurity: genres.has("multi-genre") ? 3 : 8,
    },
    pitchlines: { musicDiscovery: festival.cardOneLiner ?? festival.blurb, crowdEnergy: festival.cardOneLiner ?? festival.blurb },
  };
}
